<template>
  <section id="user" style="padding-top: 30px">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="user-profile">
            <div class="user-cart" v-if="bonus">
              <span class="title">КАРТ ЭЗЭМШИГЧ</span>
              <div class="cart-item">
                <p>Овог нэр :</p>
                <p>{{ user.lastName }} {{ user.firstName }}</p>
              </div>
              <div class="cart-item" style="margin-top: 0">
                <p style="flex: 2.2 !important">Картын № :</p>
                <p>{{ user.cardId }}</p>
              </div>
              <div v-if="bonus">
                <input
                  type="button"
                  class="btn add-partner-btn"
                  value="Хамтран нэмэх"
                  @click="addPartner()"
                  style="color: white"
                />
                <input
                  type="button"
                  class="btn add-children-btn"
                  value="Хүүхдийн карт үүсгэх"
                  @click="addChildren()"
                  style="color: white"
                />
              </div>
            </div>
            <div v-if="partner && bonus">
              <div
                class="user-partner"
                v-for="item in user.partners"
                :key="item.cardId"
              >
                <span class="title">ХАМТРАН ЭЗЭМШИГЧ</span>
                <div class="cart-item">
                  <p>Овог нэр :</p>
                  <p>{{ item.lastName }} {{ item.firstName }}</p>
                </div>
                <div class="cart-item" style="margin-top: 0">
                  <p>Картын №:</p>
                  <p>{{ item.cardId }}</p>
                </div>
                <!-- <div class="cart-item" style="margin-top:0;">
                                    <input type="button" class="btn remove-partner-btn" value="Хасах" @click="removePartnerRequest(item)" >
                                </div> -->
              </div>
            </div>
            <div v-if="showChildrenCard && bonus">
              <div class="user-partner">
                <span class="title">Хүүхдийн мэдээлэл</span>
                <div class="cart-item">
                  <p>Овог нэр :</p>
                  <p>
                    {{ childrenCard.lastName }} {{ childrenCard.firstName }}
                  </p>
                </div>
                <div class="cart-item" style="margin-top: 0">
                  <p>Картын №:</p>
                  <p>{{ childrenCard.walletId }}</p>
                </div>
                <input
                  type="button"
                  value="Лимит нэмэх"
                  class="btn add-limit-btn"
                  @click="showAddLimit()"
                />
              </div>
            </div>
            <div v-if="!bonus">
              <div
                class="user-partner"
                v-for="item in user.partners"
                :key="item.cardId"
              >
                <span class="title">Бизнес КАРТ ЭЗЭМШИГЧ</span>
                <div class="cart-item">
                  <p>Овог нэр :</p>
                  <p>{{ item.lastName }} {{ item.firstName }}</p>
                </div>
                <div class="cart-item" style="margin-top: 0">
                  <p>Картын №:</p>
                  <p>{{ item.cardId }}</p>
                </div>
              </div>
            </div>
            <div class="user-cart-information" v-if="bonus">
              <span class="title">КАРТЫН МЭДЭЭЛЭЛ</span>
              <div class="cart-item">
                <p>Картын хувь :</p>
                <p v-if="user.cardPercent != null">
                  {{ user.cardPercent | percent }}
                </p>
              </div>
              <div class="cart-item" style="margin-top: 0">
                <p>Бонус :</p>
                <p v-if="user.bonusBalance != null">
                  {{ user.bonusBalance | pricewithindex }}
                </p>
              </div>
              <div
                class="cart-item"
                style="margin-top: 0"
                v-if="nomin && bonus"
              >
                <p>Койн :</p>
                <p v-if="user.embBalance != null">
                  {{ user.embBalance | pricewithindex }}
                </p>
              </div>
              <div class="cart-item" style="margin-top: 0" v-if="bonus">
                <p>U-Point:</p>
                <p v-if="user.upointBalance != null">
                  {{ upointBalance | pricewithindex }}
                </p>
              </div>
              <div class="cart-item-last" style="margin-top: 0" v-if="dvip">
                <p style="margin-bottom: 0">Ашиглах боломжтой оноо</p>
                <p v-if="user.dvipBalance != null">
                  {{ user.dvipBalance | pricewithindex }}
                </p>
              </div>
              <div class="cart-item-last" style="margin-top: 0" v-if="dvip">
                <p style="margin-bottom: 0">Хуримтлагдаж байгаа оноо</p>
                <p v-if="user.dvipSavedBalance != null">
                  {{ user.dvipSavedBalance | pricewithindex }}
                </p>
              </div>
              <div class="cart-item-last" style="margin-top: 0">
                <p>Сүүлийн 2 жилийн худалдан авалтийн дүн</p>
                <p v-if="user.last2yearPurchase != null">
                  {{ user.last2yearPurchase | pricewithindexof }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <div class="user-board">
            <b-tabs v-model="activeIndex" @input="onTabChange">
              <b-tab>
                <template slot="title">
                  <img src="@/assets/icon/edit.png" alt="" /> Хэрэглэгчийн
                  мэдээлэл засах
                </template>
                <Loader v-if="!hasUser" />
                <Edit :user="user" v-if="hasUser"></Edit>
              </b-tab>
              <b-tab>
                <template slot="title">
                  <img src="@/assets/icon/pass.png" alt="" /> Нэвтрэх нууц үг
                  солих
                </template>
                <Password />
              </b-tab>
              <b-tab>
                <template slot="title">
                  <img src="@/assets/icon/pass.png" alt="" /> Гүйлгээний пин код
                  солих
                </template>
                <PinCode :phoneNumber="user.idPhone" />
              </b-tab>
              <b-tab v-if="dvip">
                <template slot="title">
                  <img src="@/assets/icon/employees.png" alt="" /> Хамтран
                  эзэмшигч
                </template>
                <Member :partner="user.partners" />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- <transition name="fade"> -->
    <AddChilrdenMain
      v-if="showAddKid"
      :user="user"
      @hideChildrenModal="hideChildrenModal"
    ></AddChilrdenMain>
    <!-- </transition> -->
    <transition name="fade">
      <AddPartner
        v-if="showAddPartner"
        @hidePartnerModal="hidePartnerModal"
        @setPartner="setPartner"
      ></AddPartner>
    </transition>
    <transition name="fade">
      <DeletePartner
        :cardNo="user.cardId"
        :cardPercent="cardPercent"
        :cardBalance="cardBalance"
        :purchaseAmount="purchaseAmount"
        :partnerCardNo="partnerCardNo"
        :fullName="partnerFullName"
        :partnerCardPercent="partnerCardPercent"
        :partnerCardBalance="partnerCardBalance"
        :partnerPurchaseAmount="partnerPurchaseAmount"
        v-if="showDeletePartner"
        @hideDeletePartnerModal="hideDeletePartnerModal"
        @deletePartner="deletePartner"
      ></DeletePartner>
    </transition>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
    <transition name="fade">
      <Success
        :statusCodeEbarimt="statusCodeEbarimt"
        :resultDataEbarimt="resultDataEbarimt"
        :resultDataEbarimtMsg="resultDataEbarimtMsg"
        :statusCodeEmail="statusCodeEmail"
        :resultDataEmail="resultDataEmail"
        v-if="successAddPartnerModal"
        @hidePartnerAddSuccessModal="hidePartnerAddSuccessModal"
      ></Success>
    </transition>
    <transition name="fade">
      <AddChildrenCardLimit
        v-if="showAddLimitModal"
        :childrenCard="childrenCard"
        @close="showAddLimitModal = false"
      ></AddChildrenCardLimit>
    </transition>
  </section>
</template>

<script>
import Password from "./Password";
import PinCode from "./PinCode";
import Edit from "./Edit";
import Member from "./MemberTab";
import AddPartner from "./AddPartner";
import DeletePartner from "./DeletePartner";
import Loader from "@/views/plugin/loader";
import Success from "@/views/plugin/successRelate";
import AddChilrdenMain from "./add-children/main";
import AddChildrenCardLimit from "./AddChildrenCardLimit.vue";

export default {
  data() {
    return {
      user: {},
      partner: false,
      nomin: true,
      upointBalance: 0,
      hasUser: false,
      dvip: false,
      showAddPartner: false,
      showDeletePartner: false,
      partnerCardNo: "",
      partnerFullName: "",
      partnerCardPercent: 0,
      partnerCardBalance: 0,
      partnerPurchaseAmount: 0,
      cardPercent: 0,
      cardBalance: 0,
      purchaseAmount: 0,
      errorModal: false,
      errorMessage: "",
      successAddPartnerModal: false,
      statusCodeEbarimt: 0,
      resultDataEbarimtMsg: "",
      resultDataEbarimt: [],
      statusCodeEmail: 0,
      resultDataEmail: "",
      resultHdrMsg: "",
      bonus: false,
      showAddKid: false,
      showChildrenCard: false,
      childrenCard: {},
      showAddLimitModal: false,
      activeIndex: 0,
      tabKeysBase: ["edit", "password", "pincode", "member"],
    };
  },
  computed: {
    tabKeys() {
      return this.dvip
        ? this.tabKeysBase
        : this.tabKeysBase.filter((k) => k !== "member");
    },
  },
  methods: {
    showAddLimit() {
      this.showAddLimitModal = true;
    },
    deletePartner() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      var partnerPinCode = this.$auth.getPartnerPinCode();
      this.$axiosApi
        .post(`card/info/partnerRequest`, {
          tokenId,
          cardHolderKey: user.cardHolderInfId,
          partnerCardHolderKey: this.partnerCardNo,
          type: "Remove",
          pinCode: partnerPinCode,
        })
        .then((response) => {
          var data = response.data;
          if (response.data.status === 0) {
            this.successAddPartnerModal = true;
            this.showDeletePartner = false;
            //ebarimt
            this.statusCodeEbarimt = data.statusCodeEbarimt;
            this.statusCodeEmail = data.statusCodeEmail;
            this.resultHdrMsg = "хасах";

            if (data.statusCodeEbarimt === 1) {
              this.resultDataEbarimt = JSON.parse(data.resultDataEbarimt);
            } else {
              this.resultDataEbarimt = data.resultDataEbarimt;
              this.resultDataEbarimtMsg =
                "НӨАТУС-тэй холбогдож чадсангүй. Таны И-баримт 72 цагийн дотор бүртгэлтэй имэйл рүү тань нөхөж илгээгдэнэ. Хэрвээ илгээгдээгүй бол та гүйлгээний дэлгэрэнгүй хэсгээс имэйлээр авах дээр дарж ибаримтаа авна уу..";
            }

            this.resultDataEmail = data.resultDataEmail;
            //ebarimt
            this.$insProgress.finish();
          } else {
            alert(data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removePartnerRequest(partner) {
      this.partnerCardNo = partner.cardId;
      this.partnerFullName = partner.lastName + " " + partner.firstName;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      this.$axiosApi
        .post(`card/info/partnerRequest`, {
          tokenId,
          cardHolderKey: user.cardHolderInfId,
          partnerCardHolderKey: this.partnerCardNo,
          type: "Remove",
          pinCode: "",
        })
        .then((response) => {
          var data = response.data;
          if (response.data.status === 0) {
            this.partnerCardPercent = data.relateCardNumberPercent;
            this.partnerCardBalance = data.relateCardNumberBalance;
            this.partnerPurchaseAmount = data.relateCardNumberTotalPurchase;
            this.cardPercent = data.cardNumberPercent;
            this.cardBalance = data.cardNumberBalance;
            this.purchaseAmount = data.cardNumberTotalPurchase;
            this.showDeletePartner = true;
          } else {
            this.errorModal = true;
            this.errorMessage = data.message;
          }
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage = error;
        });
    },
    setPartner() {
      // var tokenId = localStorage.getItem("authToken");
      var partCardHolderKey = this.$auth.getPartnerCardHolderKey();
      var partnerPinCode = this.$auth.getPartnerPinCode();
      var user = this.$auth.getMe();
      this.$internalApi
        .post(
          `card-relate/add`,
          {
            // tokenId,
            cardNumber: user.cardHolderInfId,
            relateCardNumber: partCardHolderKey,
            systemId: "Web",
            pinCode: partnerPinCode,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var data = response.data;
          if (response.status === 200) {
            this.successAddPartnerModal = true;
            this.showAddPartner = false;
            //ebarimt
            this.statusCodeEbarimt = data.statusCodeEbarimt;
            this.statusCodeEmail = data.statusCodeEmail;
            this.resultHdrMsg = "нэмэх";

            if (data.statusCodeEbarimt === 1) {
              this.resultDataEbarimt = JSON.parse(data.resultDataEbarimt);
            } else {
              this.resultDataEbarimt = data.resultDataEbarimt;
              this.resultDataEbarimtMsg =
                "НӨАТУС-тэй холбогдож чадсангүй. Таны И-баримт 72 цагийн дотор бүртгэлтэй имэйл рүү тань нөхөж илгээгдэнэ. Хэрвээ илгээгдээгүй бол та гүйлгээний дэлгэрэнгүй хэсгээс имэйлээр авах дээр дарж ибаримтаа авна уу..";
            }

            this.resultDataEmail = data.resultDataEmail;
            //ebarimt
            this.$insProgress.finish();
          } else {
            alert(data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hidePartnerAddSuccessModal() {
      this.successAddPartnerModal = false;
    },
    showPartnerAddSuccessModal() {
      this.successAddPartnerModal = true;
    },
    hideDeletePartnerModal() {
      this.showDeletePartner = false;
    },
    addPartner() {
      this.showAddPartner = true;
    },
    hidePartnerModal() {
      this.showAddPartner = false;
    },
    hideChildrenModal() {
      this.showAddKid = false;
    },
    hideErrorMessage() {
      this.errorModal = false;
    },
    addChildren() {
      this.showAddKid = true;
    },
    //get user logged in
    userandupoint() {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      const cardHolderInfId = userOwnData.cardHolderInfId;
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var resultInfo = response.data;
          if (resultInfo.status === 0) {
            if (resultInfo.partners != null && resultInfo.isDVIP == 0) {
              this.partner = true;
            }
            if (resultInfo.isEmployee == 0) {
              this.nomin = false;
            }
            if (resultInfo.isDVIP == 1 && resultInfo.dvip_TYPE == "Y") {
              this.dvip = true;
            }
            this.user = resultInfo;
            this.hasUser = true;
            if (resultInfo.CartType === "Bonus") {
              this.bonus = true;
            }
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
      this.$bonusApi
        .post(
          "bonus-card/upoint/card",
          {
            locationKey: 200805130000000001,
            posKey: 1,
            systemId: "BONUS",
            data: {
              card_number: cardHolderInfId,
              mobile: "",
              pin_code: "NominApproved",
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.result === 0) this.upointBalance = result.balance;
          else this.upointBalance = 0;
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
    },
    checkChildCard() {
      var userOwnData = this.$auth.getMe();
      if (!userOwnData) {
        // Optionally redirect or handle the missing user
        return;
      }
      var cardHolderInfId = userOwnData.cardHolderInfId;
      this.$bonusApi
        .post(
          "kid-card/check",
          {
            walletId: cardHolderInfId,
            systemId: "BONUS",
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data.success === true) {
            this.showChildrenCard = true;
            this.childrenCard = response.data.kidInfo;
          }
        })
        .catch((error) => {
          console.log(error, "ERROR");
        });
    },
    onTabChange(newIndex) {
      const key = this.tabKeys[newIndex] || "edit";
      this.pushTabToUrl(key);
    },
    pushTabToUrl(key, replace = false) {
      // Query хувилбар (жишээ: /profile?tab=pincode)
      const next = {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, tab: key },
        hash: "", // Хэрвээ hash хэрэглэх бол: `#${key}`
      };
      replace ? this.$router.replace(next) : this.$router.push(next);
    },
  },
  created() {
    this.checkChildCard();
    this.userandupoint();
    // this.cardInfoList();
    const hTab = (this.$route.hash || "").replace(/^#/, "") || null;

    const want = hTab || "edit";
    const idx = this.tabKeys.indexOf(want);
    this.activeIndex = idx >= 0 ? idx : 0;
  },
  watch: {
    // dvip асинхроноор ирж өөрчлөгдвөл идэвхтэй индексээ дахин тооцоолно
    dvip() {
      const key = this.tabKeys[this.activeIndex] || "edit";
      const idx = this.tabKeys.indexOf(key);
      this.activeIndex = idx >= 0 ? idx : 0;
      this.pushTabToUrl(key, /*replace=*/ true);
    },
    // URL-ийн query/hash өөрчлөгдвөл табаа синк хийж болно
    "$route.query.tab"(val) {
      if (!val) return;
      const idx = this.tabKeys.indexOf(val);
      if (idx >= 0 && idx !== this.activeIndex) this.activeIndex = idx;
    },
    "$route.hash"(val) {
      if (!val) return;
      const key = val.replace(/^#/, "");
      const idx = this.tabKeys.indexOf(key);
      if (idx >= 0 && idx !== this.activeIndex) this.activeIndex = idx;
    },
  },
  components: {
    Password,
    Edit,
    Loader,
    Member,
    PinCode,
    AddPartner,
    DeletePartner,
    Success,
    AddChilrdenMain,
    AddChildrenCardLimit,
  },
};
</script>

<style>
#user {
  margin-top: 40px;
}
.user-profile {
  background: #fff;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
}

.user-cart,
.user-partner,
.user-cart-information {
  padding: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #d8d8d8;
  height: auto;
  display: flex;
  flex-direction: column;
}
.user-cart .title {
  font-size: 14px;
  color: #1660ab;
  font-weight: bold;
}
.user-cart .cart-item {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.user-cart .cart-item p:nth-child(1) {
  flex: 1.5;
  margin-bottom: 0;
  margin-top: 10px;
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
}
.user-cart .cart-item p:nth-child(2) {
  flex: 3;
  margin-top: 10px;
  text-align: right;
  margin-bottom: 0;
  font-size: 13px;
  line-height: 22px;
  display: flex;
  justify-content: flex-end;
  color: #000000;
  text-transform: capitalize;
}
.user-partner .title {
  font-size: 14px;
  color: #1660ab;
  font-weight: bold;
}
.user-partner .cart-item {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.user-partner .cart-item p:nth-child(1) {
  flex: 2;
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
}
.user-partner .cart-item p:nth-child(2) {
  flex: 3;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;
  color: #000000;
  text-transform: capitalize;
  text-align: right;
}
.user-cart-information .title {
  font-size: 14px;
  color: #1660ab;
  font-weight: bold;
}
.user-cart-information .cart-item {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.user-cart-information .cart-item p:nth-child(1) {
  flex: 2;
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
}
.user-cart-information .cart-item p:nth-child(2) {
  flex: 3;
  font-size: 13px;
  margin-bottom: 0;
  line-height: 22px;
  display: flex;
  justify-content: flex-end;
  color: #000000;
}
.user-cart-information .cart-item-last {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}
.user-cart-information .cart-item-last p:nth-child(1) {
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-start;
}
.user-cart-information .cart-item-last p:nth-child(2) {
  flex: 1;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;
  color: #000000;
}

.user-board {
  background: #fff;
  padding: 20px;
  border-radius: 0.5rem;
  -webkit-box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 7px 35px -6px rgba(0, 0, 0, 0.2);
}

.user-edit-profile {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}
.user-edit-profile .title {
  font-size: 16px;
  width: 100%;
  color: #1660ab;
  font-weight: 500;
  text-align: center;
}
.user-edit-panel-profile {
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.user-edit-panel-profile .form-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.user-edit-panel-profile .form-group label {
  flex: 1;
  font-size: 10px;
  line-height: 30px;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-end;
}
.user-edit-panel-profile .form-group label {
  margin-right: 11px;
}
.user-edit-panel-profile .form-group .user-input {
  display: flex;
  justify-content: flex-start;
  flex: 2;
  border-radius: 2px;
}
.user-edit-panel-profile .form-group .user-input input {
  height: 30px;
  width: 70%;
  font-size: 13px;
}
.user-edit-panel-profile .form-group .age {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  justify-content: flex-start;
}
.user-edit-panel-profile .form-group .age label {
  display: flex;
  justify-content: flex-start;
}
.user-edit-panel-profile .form-group .user-age {
  width: 30% !important;
}
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #1660ab;
  border-radius: 50%;
}
.user-edit-panel-profile .form-group .age label {
  position: relative;
  flex: 0;
  cursor: pointer;
}
.user-edit-panel-profile .form-group .age input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.user-edit-panel-profile .form-group .age:hover input ~ .checkmark {
  background-color: #fff;
}
.user-edit-panel-profile .form-group .age input:checked ~ .checkmark {
  background-color: #2196f3;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.user-edit-panel-profile .form-group .age input:checked ~ .checkmark:after {
  display: block;
}
.user-edit-panel-profile .form-group .age .checkmark:after {
  top: 5px;
  left: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.user-edit-panel-profile .form-group .age p {
  margin-left: 30px;
  margin-bottom: 0;
}
.user-edit-panel-profile .user-btn {
  width: 180px;
  height: 45px;
  border-radius: 5px;
  background-color: #1660ab;
  font-size: 13px;
  color: #ffffff;
}
.nav-tabs {
  display: flex !important;
}

.nav-tabs .nav-link {
  font-size: 13px;
  border: none !important;
  color: rgba(0, 0, 0, 0.5);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-bottom: 2px solid #1660ab !important;
  color: #000 !important;
}
.add-partner-btn {
  height: 40px !important;
  border-radius: 5px !important;
  background-color: #1660ab !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 12px;
  width: 100%;
  margin-top: 5px;
}
.add-children-btn {
  height: 40px !important;
  border-radius: 5px !important;
  background-color: #4fa0f1 !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 12px;
  width: 100%;
  margin-top: 5px;
}
.add-limit-btn {
  height: 30px !important;
  border-radius: 5px !important;
  background-color: #4fa0f1 !important;
  text-align: center !important;
  color: #ffffff !important;
  font-size: 12px !important;
  width: 100%;
  margin-top: 2px;
}
.remove-partner-btn {
  height: 30px !important;
  border-radius: 5px !important;
  background-color: #ed3237 !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 12px;
  width: 100%;
  margin-top: 5px;
}
</style>
